// extracted by mini-css-extract-plugin
export var form = "_46-0";